function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { ViewArchiveFile } from "../../../tools";
import { ViewPlainText } from "./view-plain-text.component";
export const ViewArchiveXml = props => /*#__PURE__*/React.createElement(ViewArchiveFile, props, file => /*#__PURE__*/React.createElement(ViewPlainText, _extends({
  file: file
}, props.common, props.text, {
  highlight: {
    enabled: true,
    languages: ['xml']
  }
})));
export const ViewArchiveCss = props => /*#__PURE__*/React.createElement(ViewArchiveFile, props, file => /*#__PURE__*/React.createElement(ViewPlainText, _extends({
  file: file
}, props.common, props.text, {
  highlight: {
    enabled: true,
    languages: ['css']
  }
})));
export const ViewArchiveTxt = props => /*#__PURE__*/React.createElement(ViewArchiveFile, props, file => /*#__PURE__*/React.createElement(ViewPlainText, _extends({
  file: file
}, props.common, props.text)));